import { render } from "./ModalAutores.vue?vue&type=template&id=621b0d57&scoped=true"
import script from "./ModalAutores.vue?vue&type=script&lang=js"
export * from "./ModalAutores.vue?vue&type=script&lang=js"

import "./ModalAutores.vue?vue&type=style&index=0&id=621b0d57&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-621b0d57"

export default script